import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Preventivo, EmissioneResponseDTO, GetSignLinkResponseDTO } from '../shared/preventivo';

import { timer, of, throwError, Subscription } from 'rxjs';
import { concatMap, take, takeWhile, catchError, finalize } from 'rxjs/operators';

import { BackendApi } from '../shared/backend-api';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-step6',
  imports: [
    CommonModule
  ],
  templateUrl: './step6.html',
  styleUrl: './step6.css'
})

export class Step6 implements OnInit, OnDestroy {
  loading = true;
  signLink: string | null = null;
  errore: string | null = null;

  emissione: EmissioneResponseDTO | null = null;
  
  metodoPagamento?: string;

  pollingSubscription!: Subscription;

  constructor(private preventivoService: Preventivo, private api: BackendApi) {
    this.metodoPagamento = this.preventivoService.getMetodoPagamento();
    this.emissione = this.preventivoService.getEmissioneResponse();
  }

  ngOnInit(): void {
    this.startPolling();
  }

  startPolling(): void {
    // Se stai ripartendo, chiudi il polling precedente
    this.stopPolling();

    // Mostra loader e pulisci lo stato d’errore
    this.loading = true;
    this.errore = null;

    if (!this.emissione?.contractId) {
      this.errore = 'Dati mancanti per avviare il polling (contractId non disponibile).';
      this.loading = false;
      return;
    }

    const maxTentativi = 12;

    this.pollingSubscription = timer(0, 10000) // ogni 10 secondi
      .pipe(
        take(maxTentativi), // <-- limita il numero di tentativi
        concatMap(() => {
          return this.api.getSignLink(this.emissione!.contractId).pipe(
            catchError((err: HttpErrorResponse) => {
              if (err.status === 404) {
                // link non pronto: continua il polling
                return of({ signLink: null } as GetSignLinkResponseDTO);
              }
              // 401/403/500 ecc. -> interrompi e gestisci l'errore a video
              return throwError(() => err);
            })
          );
        }),
        takeWhile(response => !response.signLink, true), // continua fino a quando troviamo signLink
        finalize(() => {
          // chiamato sia su successo che su errore/timeout
          this.loading = false;
          if (!this.signLink) {
            this.errore = 'Impossibile recuperare i dati per la firma. Riprovare oppure contattare il Broker.';
          }
        })
      )
      .subscribe({
        next: response => {
          if (response.signLink) {
            this.signLink = response.signLink;
          }
        },
        error: () => {
          this.errore = 'Errore durante il recupero del link di firma.';
        }
      });
  }

  stopPolling(): void {
    if (this.pollingSubscription && !this.pollingSubscription.closed) {
      this.pollingSubscription.unsubscribe();
    }
  }

  firmaPolizza(): void {
    if (this.signLink) {
      window.open(this.signLink, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  vaiAlPagamento() {
    if (this.emissione?.redirectUrl) {
      window.open(this.emissione.redirectUrl, '_blank');
    }
  }
}
